import { getDateTimePickerComponents } from '..';
import DataGrid2 from '../../..';
import { IControlProperties } from '../../../../../../../entities';
import { IDataGridColumn } from '../../../entities';
import { getCheckUniqueValueComponent, getRequiredRuleComponent } from '../components';
import { getHeaderFilterComponent } from './getHeaderFilterComponent';

export const getChildComponents = (
	dataGrid: DataGrid2,
	bcColumn: IDataGridColumn<IControlProperties>
) => {
	switch (bcColumn.editType) {
		case 'checkBox':
		case 'numberBox':
		case 'textBox':
			return getHeaderFilterComponent(dataGrid, bcColumn);
		case 'multiLanguageTextBox':
		case 'comboBox':
		case 'fileSelect':
			break;
		case 'timePicker':
		case 'datePicker':
		case 'dateTimePicker':
			return getDateTimePickerComponents(dataGrid, bcColumn);
		case 'dateRangePicker':
			break;
	}
};

export const getValidationComponents = (bcColumn: IDataGridColumn<IControlProperties>) => {
	const components: JSX.Element[] = [];

	if (
		(!bcColumn.allowNull || bcColumn.isPrimaryKey) &&
		bcColumn.visible &&
		bcColumn.dbType.type !== 'boolean'
	) {
		components.push(getRequiredRuleComponent(bcColumn));
	}

	if (bcColumn.checkUniqueValue || bcColumn.isPrimaryKey) {
		components.push(getCheckUniqueValueComponent(bcColumn));
	}

	return components;
};
